/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Deleteeventliveroommany4Inputs */

const en_deleteeventliveroommany4 = /** @type {(inputs: Deleteeventliveroommany4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} people are in the Live Room right now. Deleting ends the Live Room for everyone.`)
};

const de_deleteeventliveroommany4 = /** @type {(inputs: Deleteeventliveroommany4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerade sind ${i?.count} Leute im Live Room. Löschen beendet den Live Room für alle.`)
};

/**
* | output |
* | --- |
* | "{count} people are in the Live Room right now. Deleting ends the Live Room for everyone." |
*
* @param {Deleteeventliveroommany4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const deleteeventliveroommany4 = /** @type {((inputs: Deleteeventliveroommany4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deleteeventliveroommany4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deleteeventliveroommany4(inputs)
	return de_deleteeventliveroommany4(inputs)
});
export { deleteeventliveroommany4 as "deleteEventLiveRoomMany" }